import IconTrash from "app/components/Icon/components/IconTrash/IconTrash";
import { IconLock } from "app/components/Icon/Icon";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./BetBuilderBetSlipButton.scss";

type Props = {
  showLockButton: boolean;
  showRedundantButton: boolean;
  onRemoveAllRedundant: () => void;
  isError: boolean;
  removeBet: () => void;
};

const BetBuilderBetSlipButton: React.FC<Props> = ({
  showLockButton,
  showRedundantButton,
  onRemoveAllRedundant,
  removeBet,
}) => {
  return (
    <div className="bet-builder-betslip-buttons">
      {showLockButton ? (
        <>
          <button className="betslip-buttons__submit-button locked" disabled>
            <IconLock />
          </button>
          <button
            onClick={removeBet}
            className="betslip-buttons__remove-button"
          >
            <IconTrash />
          </button>
        </>
      ) : (
        showRedundantButton && (
          <>
            <button
              onClick={onRemoveAllRedundant}
              className="betslip-buttons__submit-button"
            >
              <FormattedMessage
                tagName="span"
                id="remove-redundant-selections"
              />
            </button>
            <button
              onClick={removeBet}
              className="betslip-buttons__remove-button"
            >
              <IconTrash />
            </button>
          </>
        )
      )}
    </div>
  );
};

export default BetBuilderBetSlipButton;
